import { createFileRoute } from "@tanstack/react-router";

import TargetSidebar from "@/components/Targets/TargetSidebar";

const Component = () => {
  const { climbType: climbTypeParam, targetUuid } = Route.useParams();
  const climbType = climbTypeParam.toUpperCase();
  if (climbType !== "BOULDER" && climbType !== "SPORT") {
    throw new Error("Invalid climb type");
  }
  return <TargetSidebar climbType={climbType} uuid={targetUuid} />;
};
export const Route = createFileRoute("/gym/$venueUuid/settings/targets/$climbType/$targetUuid")({
  component: Component,
});
